var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"jsp-loader"},[_c('div',{staticClass:"block",class:{ fill: _vm.fill }},[_c('BallPulseSyncLoader',{attrs:{"size":"16px"}}),_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }